import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { AdminMechanic } from '../models/admin.models';
import { ApiResponse, PaginatedResponse } from '../models/api-response.model';

@Injectable({
  providedIn: 'root'
})
export class AdminMechanicsService {
  private baseUrl = `${environment.apiBaseUrl}/admin/mechanics`;

  constructor(private http: HttpClient) {}

  /**
   * GET /api/v1/admin/mechanics
   * Returns paginated list of all mechanics.
   */
  getMechanics(): Observable<PaginatedResponse<AdminMechanic>> {
    return this.http.get<any>(this.baseUrl).pipe(
      map(res => res.data ?? res)
    );
  }

  /**
   * GET /api/v1/admin/mechanics/:id
   * Returns full profile of a single mechanic.
   */
  getMechanic(id: number): Observable<AdminMechanic> {
    return this.http.get<ApiResponse<AdminMechanic>>(`${this.baseUrl}/${id}`).pipe(
      map(res => res.data)
    );
  }

  /**
   * PUT /api/v1/admin/mechanics/:id/verify
   * Verifies or un-verifies a mechanic.
   */
  verifyMechanic(id: number, verified: boolean): Observable<AdminMechanic> {
    return this.http.put<ApiResponse<AdminMechanic>>(
      `${this.baseUrl}/${id}/verify`,
      { verified }
    ).pipe(map(res => res.data));
  }

  /**
   * POST /api/v1/admin/users/:id/block
   * Blocks a mechanic user account.
   */
  blockMechanic(userId: number): Observable<void> {
    return this.http.post<void>(
      `${environment.apiBaseUrl}/admin/users/${userId}/block`,
      {}
    );
  }

  /**
   * POST /api/v1/admin/users/:id/unblock
   * Unblocks a mechanic user account.
   */
  unblockMechanic(userId: number): Observable<void> {
    return this.http.post<void>(
      `${environment.apiBaseUrl}/admin/users/${userId}/unblock`,
      {}
    );
  }
}
